import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = ["for"]

import Button from 'primevue/button'
import Checkbox from 'primevue/checkbox'
import {
  ref,
  reactive,
  toRefs,
  watch,
  getCurrentInstance,
  onMounted,
  computed
} from 'vue'
import { useStore } from 'vuex'

const moduleStore = 'employee'

export default /*@__PURE__*/_defineComponent({
  __name: 'FilterOptions',
  props: {
  dataList: {
    default: [] as any
  },
  selectedFilter: {
    default: [] as any
  }
},
  emits: ["onSubmit", "hidePanel"],
  setup(__props, { emit: __emit }) {

const props = __props

const {
  dataList,
  selectedFilter
} = toRefs(props)

const emit = __emit

const store = useStore()
const app = getCurrentInstance()
const {
  $icon
} = app!.appContext.config.globalProperties
const icon = $icon
const selectedFieldIndex = ref(null) as any
const appliedOptions = ref([]) as any
const selectedFieldOption = computed(() => store.getters['violenceCard/getViolenceCardFilter'] || [])
const selectedFieldOptionLocal = ref([]) as any

const deepClone = (v: any) => JSON.parse(JSON.stringify(v))

const selectedField = (val: any) => {
  if (selectedFieldIndex.value === val) {
    selectedFieldIndex.value = null
  } else {
    selectedFieldIndex.value = val
  }
}

const onSubmitAct = () => {
  store.dispatch('violenceCard/setViolenceCardFilter', selectedFieldOptionLocal.value)
  emit('onSubmit', selectedFieldOptionLocal.value)
  // eslint-disable-next-line no-use-before-define
  hidePanelAct()
}

const resetFilterAct = () => {
  selectedFieldOptionLocal.value = []
  store.dispatch('violenceCard/flushViolenceCardFilter')
  emit('onSubmit', selectedFieldOptionLocal.value)
  // eslint-disable-next-line no-use-before-define
  hidePanelAct()
}

const hidePanelAct = () => {
  emit('hidePanel')
}

// watch(selectedFieldOption.value, (val: any) => {
//   console.log('val', val)
//   console.log('selectedFieldOption', selectedFieldOption.value)
//   console.log('store', store.state[moduleStore].filters)
// })

onMounted(() => {
  // console.log(selectedFilter.value)
  selectedFieldOptionLocal.value = deepClone(selectedFieldOption.value) || []
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), (data, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: data,
          class: "mb-1"
        }, [
          _createVNode(_unref(Checkbox), {
            modelValue: selectedFieldOptionLocal.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedFieldOptionLocal).value = $event)),
            inputId: `position${index}`,
            value: data,
            onChange: onSubmitAct
          }, null, 8, ["modelValue", "inputId", "value"]),
          _createElementVNode("label", {
            for: `position${index}`,
            class: "ml-2"
          }, _toDisplayString(data?.Name), 9, _hoisted_2)
        ]))
      }), 128))
    ])
  ]))
}
}

})